import React, { useEffect, useState } from "react";
import Participant from "./Participant.jsx";

const Room = ({ roomName, room, handleLogout }) => {
	const [participants, setParticipants] = useState([]);

	useEffect(() => {
		const participantConnected = (participant) => {
			console.log('participantConnected', participant);
			setParticipants((prevParticipants) => [...prevParticipants, participant]);
		};

		const participantDisconnected = (participant) => {
			console.log('participantDisconnected', participant);
			setParticipants((prevParticipants) =>
				prevParticipants.filter((p) => p !== participant)
			);
		};

		room.on("participantConnected", participantConnected);
		room.on("participantDisconnected", participantDisconnected);
		room.participants.forEach(participantConnected);

		return () => {
			room.off("participantConnected", participantConnected);
			room.off("participantDisconnected", participantDisconnected);
		};
	}, [room]);

	const remoteParticipants = participants.map((participant) => (
		<Participant key={participant.sid} participant={participant} />
	));

	return (
		<div className="room">
			<h2>Room: {roomName}</h2>
			{/* <button onClick={handleLogout}>Log out</button> */}
			<div className="row">
				<div className="col-12 col-lg-8">
					<div className="local-participant">
						<h2>Yourself</h2>
						{room ? (
						<Participant
							key={room.localParticipant.sid}
							participant={room.localParticipant}
						/>
						) : (
						""
						)}
					</div>
				</div>
				<div className="col-12 col-lg-4">
					<h3>Remote Participants</h3>
					<div className="remote-participants">{remoteParticipants}</div>
				</div>
			</div>

		</div>
	);
};

export default Room;
